import { INDICES, INDICES_ERROR, INDICES_HIDE_ERROR, INDICES_START_LOADER, INDICES_STOP_LOADER, INDICES_STREAM, } from "../interface/iIndices";
import { indicesStreamingUpdated } from "@domains/features/Markets/Equity/utils/streamingUpdate";
const initState = {
    data: {},
    loader: true,
    errorData: {
        error: null,
        isOpen: false,
    },
    updatedTime: "",
};
const indices = (state = initState, action) => {
    switch (action.type) {
        case INDICES:
            return Object.assign(Object.assign({}, state), { data: action.payload.data, updatedTime: action.payload.updatedTime });
        case INDICES_STREAM:
            return Object.assign(Object.assign({}, state), { data: indicesStreamingUpdated([state.data], action.payload.quoteStream)[0], updatedTime: action.payload.quoteStream.updatedTime });
        case INDICES_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case INDICES_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case INDICES_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case INDICES_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default indices;
